import React from 'react'
import PropTypes from 'prop-types'
import TitleBar from '../Layout/titleBar'
import { Row, Col } from 'react-flexbox-grid'
import Paper from '@material-ui/core/Paper'
import TextField from '@material-ui/core/TextField'
import MenuItem from '@material-ui/core/MenuItem'

import './styles.css'

const SucursalNew = ({
  sucursal,
  error,
  handleOnSaveSucursal,
  handleOnCancel,
  handleOnChange
}) => {

  return (
    <div className='crearEditarSucursal'>
      {/* menú superior */}
      <TitleBar
        title={'Nueva sucursal'}
        type='createArticulo'  /** tiene guardar y cancelar */
        handleOnSave={handleOnSaveSucursal}
        handleOnBack={handleOnCancel}
        showSearch={false}
      />

      {/* panel */}
      <Paper className='myBox no-margin'>
        <Row>
          <Col md={6}>
            <TextField className='myInput'
              label='Nombre'
              name='nombre'
              fullWidth
              required
              autoComplete='off'
              error={error && error.nombre}
              helperText={(error && error.nombre) ? error.nombre : ""}
              value={sucursal.nombre}
              onChange={(e) => {
                const value = e.target.value;
                if (/^[a-zA-Z0-9áéíóúÁÉÍÓÚ\s]*$/.test(value)) {
                  handleOnChange(e);
                }
              }}
            />
          </Col>
          <Col md={6}>
            <TextField className='myInput'
              label='Dirección'
              name='direccion'
              autoComplete='off'
              fullWidth
              required
              error={error && error.direccion}
              helperText={(error && error.direccion) ? error.direccion : ""}
              value={sucursal.direccion}
              onChange={(e) => {
                const value = e.target.value;
                if (/^[a-zA-Z0-9áéíóúÁÉÍÓÚ\s]*$/.test(value)) {
                  handleOnChange(e);
                }
              }}
            />
          </Col>
          <Col md={6}>
            <TextField className='myInput'
              label='Telefóno'
              name='telefono'
              autoComplete='off'
              fullWidth
              required
              error={error && error.telefono}
              helperText={(error && error.telefono) ? error.telefono : ""}
              value={sucursal.telefono}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\+?[0-9]*$/.test(value)) {
                  handleOnChange(e);
                }
              }}
            />
          </Col>
          <Col md={6}>
            <TextField className='myInput'
              label='Whatsapp'
              name='whatsapp'
              autoComplete='off'
              fullWidth
              required
              error={error && error.whatsapp}
              helperText={(error && error.whatsapp) ? error.whatsapp : ""}
              value={sucursal.whatsapp}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\+?[0-9]*$/.test(value)) {
                  handleOnChange(e);
                }
              }}

            />
          </Col>
          <Col md={6}>
            <TextField className='myInput'
              label='Link ubicación'
              name='linkUbicacion'
              autoComplete='off'
              fullWidth
              required
              error={error && error.linkUbicacion}
              helperText={(error && error.linkUbicacion) ? error.linkUbicacion : ""}
              value={sucursal.linkUbicacion}
              onChange={handleOnChange}
            />
          </Col>
        </Row>
      </Paper>
    </div>
  )
}

export default SucursalNew;